export const getDomain = (host) => {
  if (typeof host !== 'string') {
    return host;
  }

  return host.split('.').slice(-2).join('.');
};

export default getDomain;
